<template>
  <div class="personalisation-informations-wrapper">
    <div class="personalisation-activity-wrapper">
      <div :id="`perso-list-status-${personalisation.deviceId}-${personalisation.createdData}`" class="personalisation-attribute d-flex">
        <img
          class="status-icon"
          :src="require(`@/assets/icons/perso/status/${getStatus(personalisation)}.svg`)"
          :title="$t(`device.personalisation.status.${getStatus(personalisation)}`)"
          :alt="personalisation.status"
        >
        <span class="status-label align-self-end ml-2">{{ $t(`device.personalisation.status.${getStatus(personalisation)}`) }}</span>
      </div>
      <div :id="`perso-list-updated-${personalisation.deviceId}-${personalisation.createdData}`" class="personalisation-attribute">
        {{ formatDateTimeSecond(convertDate(personalisation.updatedData)) }}
      </div>
      <div :id="`perso-list-type-${personalisation.deviceId}-${personalisation.createdData}`" class="personalisation-attribute">
        {{ personalisation.type }}
      </div>
      <div :id="`perso-list-device-${personalisation.deviceId}-${personalisation.createdData}`" class="personalisation-attribute">
        {{ personalisation.shortDeviceId }}
      </div>
      <div :id="`perso-list-created-${personalisation.deviceId}-${personalisation.createdData}`" class="personalisation-attribute">
        {{ formatDateTimeSecond(convertDate(personalisation.createdData)) }}
      </div>
      <div :id="`perso-list-operation-${personalisation.deviceId}-${personalisation.createdData}`" class="personalisation-attribute">
        {{ personalisation.operationType }}
      </div>
      <div :id="`perso-list-variant-${personalisation.deviceId}-${personalisation.createdData}`" class="personalisation-attribute">
        {{ personalisation.variant.name }}
      </div>
      <div :id="`perso-list-rawdata-${personalisation.deviceId}-${personalisation.createdData}`" class="personalisation-attribute">
        <span>{{ personalisation.trigger.join(', ') }}</span>
        <v-icon
          v-if="!personalisation.isDeperso && personalisation.status != 'draft'"
          :id="`perso-list-info-${personalisation.deviceId}-${personalisation.createdData}`"
          :title="$t('device.personalisation.modal.title')"
          @click="displayDetailsModal(personalisation)"
        >
          mdi-information-outline
        </v-icon>
      </div>
    </div>
    <PersonalisationDetails
      v-if="detailsModal"
      :enabled="detailsModal"
      :perso="selectedPerso"
      @close="displayDetailsModal"
    />
  </div>
</template>

<script lang="ts">
import { Personalisation } from 'ctp-personalisation-search';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import Utils from '@/mixins/Utils';
import { colors } from '@/constants/theme/colors';
import { store } from '@/store/modules/permissions/types';
import PersonalisationDetails from './components/PersonalisationDetails/PersonalisationDetails.vue';
import './styles/personalisation-informations.scss';

@Component({
  components: {
    PersonalisationDetails
  }
})
export default class PersonalisationInformations extends Mixins(Utils) {
  @Prop()
  private personalisation!: Personalisation;

  @store.Getter
  private getCurrentUserIsAbleTo: (readOrWrite: string, featureName: string) => boolean;

  private selectedPerso: Personalisation = {
    masterId: 0,
    type: Personalisation.TypeEnum.Obu,
    deviceId: '',
    version: 0
  };

  private detailsModal = false;

  private themeColors = colors;

  private getCurrentUserIsAbleToWrite(featureName: string) {
    return this.getCurrentUserIsAbleTo('write', featureName);
  }

  private convertDate(date: string) {
    return moment(date).unix();
  }

  private displayDetailsModal(personalisation: Personalisation) {
    this.selectedPerso = personalisation;
    this.detailsModal = !this.detailsModal;
  }

  private getStatus(perso: Personalisation): string {
    if (perso.isDeperso) {
      return `deperso_${perso.status}`;
    }
    return perso.status!.toString();
  }
}
</script>
